import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { MaintenanceWindowData, MaintenanceWindowTypeData } from '../types';

export abstract class MaintenanceWindowFormBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getMaintenanceWindow(maintenanceWindowId: string): Promise<MaintenanceWindowData>;
  public abstract getMaintenanceWindowsTypes(): Promise<MaintenanceWindowTypeData[]>;
  public abstract getSuggestedNewMaintenanceWindowName(type: number): Promise<string>;
  public abstract createMaintenanceWindow(record: Object): Promise<Object | null>;
  public abstract updateMaintenanceWindow(record: Object): Promise<Object | null>;
}
